const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNpm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "267px",
    height: "300px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#910404",
    d: "M 125.5,-0.5 C 130.5,-0.5 135.5,-0.5 140.5,-0.5C 178.274,21.5591 216.274,43.3925 254.5,65C 260.22,68.5405 264.22,73.3739 266.5,79.5C 266.5,126.167 266.5,172.833 266.5,219.5C 264.391,224.182 261.391,228.349 257.5,232C 218.235,254.794 178.901,277.294 139.5,299.5C 134.833,299.5 130.167,299.5 125.5,299.5C 85.1827,276.586 45.0161,253.252 5,229.5C 2.6258,226.737 0.792465,223.737 -0.5,220.5C -0.5,173.167 -0.5,125.833 -0.5,78.5C 1.50325,73.3575 4.83658,69.1908 9.5,66C 48.3548,43.9372 87.0215,21.7706 125.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cb0000",
    d: "M 127.5,9.5 C 133.521,8.96494 139.187,10.1316 144.5,13C 177.337,32.2527 210.337,51.2527 243.5,70C 247.552,72.3764 248.385,75.5431 246,79.5C 210.874,100.313 175.374,120.48 139.5,140C 134.411,140.826 129.411,140.492 124.5,139C 89.7537,119.212 55.2537,99.0451 21,78.5C 18.6146,74.5431 19.4479,71.3764 23.5,69C 58.0985,48.8728 92.7652,29.0395 127.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cb0000",
    d: "M 11.5,86.5 C 14.7935,86.259 17.7935,87.0924 20.5,89C 54.5,108.667 88.5,128.333 122.5,148C 125.293,151.081 127.46,154.581 129,158.5C 129.667,199.833 129.667,241.167 129,282.5C 127.666,286.104 125.166,287.271 121.5,286C 87.1667,266.333 52.8333,246.667 18.5,227C 13.8136,223.635 10.6469,219.135 9,213.5C 8.33333,172.167 8.33333,130.833 9,89.5C 10.045,88.6266 10.8783,87.6266 11.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cb0100",
    d: "M 248.5,88.5 C 252.49,87.6155 255.323,88.9489 257,92.5C 257.667,132.167 257.667,171.833 257,211.5C 255.493,219.67 250.993,225.503 243.5,229C 211.5,247.333 179.5,265.667 147.5,284C 142.91,285.615 140.077,284.115 139,279.5C 138.333,239.5 138.333,199.5 139,159.5C 140.992,153.178 144.825,148.345 150.5,145C 183.393,126.392 216.059,107.559 248.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefcfc",
    d: "M 218.5,221.5 C 217.833,197.833 217.167,174.167 216.5,150.5C 210.031,153.902 203.697,157.569 197.5,161.5C 196.667,185.826 196.167,210.16 196,234.5C 182.888,242.305 169.721,249.971 156.5,257.5C 155.502,226.004 155.168,194.338 155.5,162.5C 182.307,146.26 209.307,130.26 236.5,114.5C 237.667,146.495 237.833,178.495 237,210.5C 230.723,214.052 224.556,217.719 218.5,221.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ea9898",
    d: "M 216.5,150.5 C 217.167,174.167 217.833,197.833 218.5,221.5C 218.44,222.043 218.107,222.376 217.5,222.5C 216.5,198.509 216.167,174.509 216.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e16a69",
    d: "M 155.5,162.5 C 155.168,194.338 155.502,226.004 156.5,257.5C 156.44,258.043 156.107,258.376 155.5,258.5C 154.17,226.336 154.17,194.336 155.5,162.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpm);
export default __webpack_public_path__ + "static/media/npm.6b444736ff46f1d91b19b0137c8439be.svg";
export { ForwardRef as ReactComponent };